import React from "react";
import * as S from "./styled";
import T from "@marginly/ui/components/typography";

interface Props {}

export function HeroTop() {
  return (
    <T headerL as={"h1"}>
      <S.HeroTop>
        <img
          src="/contest/images/camelot-left.svg"
          alt=""
          className="decor decor--left"
        />
        <img
          src="/contest/images/camelot-right.svg"
          alt=""
          className="decor decor--right"
        />
        <S.HeroBadge>
          Trade with
          <S.HeroTimes>
            <T className="headerM" as={"span"}>
              20&times;
            </T>
          </S.HeroTimes>
        </S.HeroBadge>
        <span>
          leverage
          <span className="desktop-hidden">&nbsp;&nbsp;on</span>
        </span>
      </S.HeroTop>
      <S.HeaderFlex>
        <span className="mobile-hidden">on</span>
        <S.HeroCamelot>
          <img src="/contest/images/camelot-black.svg" alt="" />
          Camelot
        </S.HeroCamelot>
      </S.HeaderFlex>
    </T>
  );
}
